import React, { useState } from 'react'
import { List } from 'core/components/list'
import { useRefresh } from 'core/hooks/refresh'
import { Button } from 'core/components/button'

const columns = [
    { path: 'businessName'},
    {path: 'streetName', render: (entity) => {
      return entity.streetName &&entity.streetNumber ?  `${entity.streetName || ''}, Nº ${entity.streetNumber || ''}` : ''
    }},
    { path: 'geoLocation', style: {textAlign: 'right'} , render : (entity) => {

        return (entity.geoLocation && (entity.geoLocation.lat !== 0 && entity.geoLocation.lng !== 0)) && <Button
            customClassName="btn-primary"
            icon="fas fa-map-marker-alt"
            onClick={() => {
                window.open(`https://www.google.com/maps/search/?api=1&query=${entity.geoLocation.lat},${entity.geoLocation.lng}`)
            }}
        />
    }},
]

const fields = columns.map(c => c.path)

export const PointOfSaleList = ({ global, route, service }) => {
    const { modal } = global
    const fetching = useState(false)
    const refresh = useRefresh()

    return (
        <>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__head kt-portlet__head--lg">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="kt-font-brand fas fa-store" />
                        </span>
                        <h3 className="kt-portlet__head-title">Pontos de Venda</h3>
                    </div>
                </div>

                <div className="kt-portlet__body kt-portlet__body--fit">
                    <List
                        columns={columns}
                        fetching={fetching}
                        getItems={() => service.get('pointofsale.list')}
                        initialQuery={{ fields }}
                        modal={modal}
                        primaryKey="id"
                        refresh={refresh}
                        route={route}
                        useCustomList
                    />
                </div>
            </div>
        </>
    )
}
